import * as React from 'react';
import { Route } from 'react-router';
import Layout from './components/layout/Layout';
import Home from './components/Home';
import SearchComponent from './components/employee/search.component';
import ResultComponent from './components/employee/result.compnent';
import './custom.css'




export default () => (
    <Layout>
        <Route exact path='/' component={Home}></Route>
        <Route path='/search' component={SearchComponent} />
        <Route path='/result' component={ResultComponent} />
    </Layout>
);
